import { useEffect, useRef } from 'react'
import { enhanceExternalLinks } from '../../utils/links'

export function isHtmlContent(value) {
  return typeof value === 'string' && /<[^>]+>/.test(value)
}

export default function CmsHtmlContent({ content, className = '', as: Tag = 'div' }) {
  const ref = useRef(null)

  useEffect(() => {
    if (!isHtmlContent(content)) return
    enhanceExternalLinks(ref.current)
  }, [content])

  if (!content) return null

  if (isHtmlContent(content)) {
    return (
      <Tag
        ref={ref}
        className={`cms-html ${className}`}
        dangerouslySetInnerHTML={{ __html: content }}
      />
    )
  }

  return <Tag className={className}>{content}</Tag>
}
